/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";

/* Husky Custom Code - Start */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";
/* Husky Custom Code - Start */

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

/* Husky Custom Code - Start */
interface PageTitleStyles {
    titleStyles?: TypographyPresentationProps;
}

const pageTitleStyles: PageTitleStyles = {
    titleStyles: {
        variant: "h1",
        forwardAs: "h1",
        css: css`
            outline: 0;
            margin-bottom: 0.5em;
        `,
    },
};

const styles = pageTitleStyles;

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => {
    const titleStylesWithFieldsData = mergeToNew(styles.titleStyles, {
        css: css`
            ${styles.titleStyles?.css}
            text-align: ${fields.alignTitle};
        `,
    });
    return (
        <Typography tabIndex={-1} data-test-selector="PageTitle" data-id="PageTitle" {...titleStylesWithFieldsData}>
            {fields.overrideTitle || pageTitle}
        </Typography>
    );
};
/* Husky Custom Code - End */

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
        // Husky Custom Code
        fieldDefinitions: [
            {
                name: "overrideTitle",
                displayName: "Override Title",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
            },
            {
                name: "alignTitle",
                displayName: "Title Alignment",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Left", value: "left" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Right", value: "right" },
                ],
                defaultValue: "left",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
